module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_TURB.4d617253.png";